import _import from './_import.js';

export default [{
	path: 'user-center',
	name: 'member',
	component: _import('member/layout'),
	redirect: {
	    name: 'member_account_list'
    },
    meta: {
        requiresAuth: true
    },
	children: [
		// 个人账户
		{
		    path: 'account',
		    name: 'member_account_list',
            component: _import('member/account/list.vue'),
            meta: {
                requiresAuth: true
            },
        },
        {
            path: 'account-detail/:ota',
            name: 'member_account_detail',
            component: _import('member/account/detail.vue'),
            meta: {
                requiresAuth: true
            },
        },
        {
            path: 'account-setting',
            name: 'member_account_setting',
            component: _import('member/account/setting.vue'),
            meta: {
                requiresAuth: true
            },
        },
        // 个人账户取消
        {
            path: 'cancel/:ota',
            name: 'member_account_cancel',
            component: _import('member/account/cancel.vue'),
            meta: {
                requiresAuth: true
            },
        },
        {
            path: 'prompt',
            name: 'member_account_prompt',
            component: _import('member/account/prompt.vue'),
            meta: {
                requiresAuth: true
            },
        },
		// 购买记录---我的订单
		{
		    path: 'myOrder',
		    name: 'member_myOrder',
		    component: _import('member/myOrder'),
            meta: {
                requiresAuth: true
            },
		},
        // 购买记录---设备订单
        {
            path: 'myDeviceOrder',
            name: 'myDeviceOrder',
            component: _import('member/myDeviceOrder'),
            meta: {
                requiresAuth: true
            },
        },
        // 购买记录---设备订单详情
        {
            path: 'myDeviceOrderDetail',
            name: 'myDeviceOrderDetail',
            component: _import('member/myDeviceOrderDetail'),
            meta: {
                requiresAuth: true
            },
        },
		// 我的余额---余额明细
		{
		    path: 'balanceDetails',
		    name: 'member_balanceDetails',
		    component: _import('member/balanceDetails'),
            meta: {
                requiresAuth: true
            },
		},
		// 流量统计---流量记录
		{
		    path: 'flowRecords',
		    name: 'member_flowRecords',
		    component: _import('member/flowRecords'),
            meta: {
                requiresAuth: true
            },
		},
		// 我的设备---设备管理
		{
		    path: 'equipmentManagement',
		    name: 'equipmentManagement',
		    component: _import('member/equipmentManagement'),
            meta: {
                requiresAuth: true
            },
		},
		// 修改密码
		{
		    path: 'modify-password',
		    name: 'modifyPassword',
		    component: _import('member/modifyPassword'),
            meta: {
                requiresAuth: true
            },
		},
		//
		{
		    path: 'modify_information',
		    name: 'modifyInformation',
		    component: _import('member/modify_information'),
            meta: {
                requiresAuth: true
            },
		},
        // 注册邮箱激活账户
        {
            path: 'activeAccount',
            name: 'active_account',
            component: _import('register/active_account')
        },
        // 注册邮箱激活账户成功
        {
            path: 'activeAccountSuc',
            name: 'active_account_suc',
            component: _import('register/active_account_suc')
        }
	]
}];



// WEBPACK FOOTER //
// ./src/router/member.js